import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from 'react-router-dom';
import { Flow } from 'signup-constants/Flow';
import FacebookCrmRoute from './FacebookCrmRoute';
import HubSpotForStartupsRoute from './HubSpotForStartupsRoute';
import IntegrationsRoute from './IntegrationsRoute';
import TrialRoute from './TrialRoute';
import { ViewContainer } from './ViewContainer';
const CustomRoutes = new Map([[Flow.Integrations, IntegrationsRoute], [Flow.Trial, TrialRoute], [Flow.FbCrm, FacebookCrmRoute], [Flow.HubspotForStartups, HubSpotForStartupsRoute]]);
export const useFlowRoutes = () => {
  const flowRoutes = Object.entries(Flow).filter(([, value]) => !CustomRoutes.has(value)).map(([key, path]) => /*#__PURE__*/_jsx(Route, {
    component: ViewContainer,
    path: `/${path}`
  }, key)); // Render all custom routes

  CustomRoutes.forEach((CustomFlowRoute, flowKey) => {
    flowRoutes.push( /*#__PURE__*/_jsx(CustomFlowRoute, {
      component: ViewContainer,
      path: `/${flowKey}`
    }, flowKey));
  });
  return flowRoutes;
};